import { css } from '@emotion/react'
import { Stack } from 'components/Stack'
import { ApiType } from 'utils/types'
import { Image } from 'components/Image'
import { pxToRem } from 'utils/styled'

export function PartnerLogos(props: {
  className?: string
  orientation?: 'horizontal' | 'vertical'
  promocode?: ApiType['PromoCodeResponse']
}) {
  return (
    <Stack
      className={props.className}
      orientation={props.orientation ?? 'horizontal'}
      space={`0.5rem`}
    >
      <Image
        src={props.promocode?.promo_code_info?.partner?.partner_photo?.url}
        css={css`
          width: ${pxToRem(294)}rem;
          height: ${pxToRem(112)}rem;
          object-fit: contain;
          object-position: left;
        `}
      />
    </Stack>
  )
}
